import { Col, Form, FormInstance, Input, Row, Select } from "antd";
import CompanyCard from "containers/Admin/CreateOrEditEvent/Cards/CompanyCard";
import { ContactPerson } from "containers/SingleJobPosting/interfaces";
import { EventType, Location } from "@bindeleddet/core/types";
import { EditEventFormType } from "../CreateOrEditEvent";

const { Option } = Select;

interface Props {
  form: FormInstance<EditEventFormType>;
  locations: Location[];
  contactPersons: ContactPerson[];
  eventTypes: EventType[];
}

const CompanyCardGeneral: React.FC<Props> = ({ form, locations, contactPersons, eventTypes }) => {
  const onLocationChange = (value: number | null) => {
    form.setFieldsValue({ location: value });
  };

  return (
    <>
      <CompanyCard title="Generelt">
        <Row>
          <Col md={12} sm={24} xs={24}>
            <Form.Item<EditEventFormType>
              name="name"
              label="Visningsnavn"
              rules={[{ required: true, message: "Skriv inn visningsnavn" }]}
            >
              <Input size="large" style={{ width: "95%", margin: "2px 5% 0 0" }} />
            </Form.Item>

            <Form.Item<EditEventFormType> name="food" label="Severing">
              <Input size="large" style={{ width: "95%", margin: "2px 5% 0 0" }} placeholder="Servering" />
            </Form.Item>

            <Form.Item<EditEventFormType> name="location" label="Lokasjon">
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const label = (option?.children ?? "").toString().toLowerCase();
                  return label.includes(input.toLowerCase());
                }}
                allowClear
                notFoundContent={
                  'Ingen lokasjoner matcher ditt søk. Du kan opprette en ny lokasjon under "Lokasjoner" under "Arrangementer" i sidemenyen.'
                }
                onChange={onLocationChange}
                size="large"
                style={{ width: "95%", margin: "2px 5% 15px 0" }}
                placeholder="Velg lokasjon"
              >
                <Option value={-1} disabled>
                  Velg lokasjon...
                </Option>
                {locations?.map(location => {
                  return (
                    <Option key={location.id} value={location.id}>
                      {location.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col md={12} sm={24} xs={24}>
            <Form.Item<EditEventFormType>
              name="event_type"
              label="Arrangementstype"
              rules={[{ required: true, message: "Velg type arrangement" }]}
            >
              <Select size="large" style={{ width: "95%", margin: "2px 5% 0 0" }} placeholder="Velg type arrangement">
                <Option value={-1} disabled>
                  Velg type arrangement...
                </Option>
                {eventTypes?.map(eventType => {
                  return (
                    <Option key={eventType.id} value={eventType.id}>
                      {eventType.title}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>

            <Form.Item<EditEventFormType> name="company_contact_id" label="Kontakt hos bedriften">
              <Select size="large" style={{ width: "95%", margin: "2px 5% 15px 0" }} placeholder="Velg bedriftskontakt">
                <Option value={-1} disabled>
                  Velg bedriftskontakt...
                </Option>
                {contactPersons?.map(contact => {
                  return (
                    <Option key={contact.id} value={contact.id}>
                      {contact.first_name} {contact.last_name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </CompanyCard>
    </>
  );
};

export default CompanyCardGeneral;
